import axios from '../axios-auth'
import orginal_axios from "axios";

export const counterCashService = {
    getCounterCashList,
    getCounterCashDetail,
    saveCounterCash,
    getCounterCashSummary,
    getCounterCashSummaryDetailList,
    getAllCounterCashList,
    exportCounterCashExcel
};

function getCounterCashList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    return axios.get("/auth/counter-cashs", { params });
}

function getAllCounterCashList(searchParams) {
    let url = '/auth/counterCashSummaryDetail';
    let params = {};
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    return axios.get(url, { params });
}
function getCounterCashDetail(id) {
    return axios.get('/auth/counter-cash/' + id);
}

function saveCounterCash(counterCash) {
    if (counterCash.id) {
        //edit
        return axios.put('/auth/counter-cash', counterCash);
    }
    else {
        // create new
        return axios.post('/auth/counter-cash', counterCash);
    }

}

function getCounterCashSummary(searchParams) {
    let url = '/auth/counterCashSummary?';

    if (searchParams.fromDate) {
        url += 'fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.cashType) {
        url += '&cashType=' + searchParams.cashType;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }

    return axios.get(url);
}

function getCounterCashSummaryDetailList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let url = '/auth/counterCashSummaryDetail?page=' + page + '&size=' + size + '&sort=' + sortedBy;
    if (searchParams.cashType) {
        url += '&cashType=' + searchParams.cashType;
    }
    if (searchParams.counterId) {
        url += '&counterId=' + searchParams.counterId;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    return axios.get(url);
}

function exportCounterCashExcel(searchParams) {
    let params = {
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.cashType) {
        params["cashType"] = searchParams.cashType;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/counter-cash-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}